import React, { useState } from 'react';
import { Container, Flex, Text, Box } from '@chakra-ui/react';
import PageTitle from '../components/PageTitle';
import StandingsChart from '../components/StandingsChart';
import { useMyLeagueStore } from '../store/myLeagueStore';

type StandingsTab = 'divisions' | 'wildcard';

const StandingsPage: React.FC = () => {
  const myLeague = useMyLeagueStore((state) => state.myLeague);
  const [activeTab, setActiveTab] = useState<StandingsTab>('divisions');

  const leagueName = myLeague?.name || '';
  const displayLeagueName = leagueName
    ? (leagueName.includes('League') ? leagueName : `${leagueName} League`)
    : 'League';

  const tabs: { key: StandingsTab; label: string }[] = [
    { key: 'divisions', label: 'Division Standings' },
    { key: 'wildcard', label: 'Wild Card' },
  ];

  return (
    <Container maxW="7xl" py={8}>
      <PageTitle mb={6}>{displayLeagueName} Standings</PageTitle>

      {/* Tab Navigation */}
      <Flex gap={0} mb={6}>
        {tabs.map((tab) => {
          const isActive = activeTab === tab.key;
          return (
            <Box
              key={tab.key}
              as="button"
              onClick={() => setActiveTab(tab.key)}
              px={5}
              py={2.5}
              fontFamily="'Exo 2', sans-serif"
              fontWeight="bold"
              fontSize="sm"
              textTransform="uppercase"
              letterSpacing="0.05em"
              cursor="pointer"
              transition="all 0.2s ease"
              borderBottom="3px solid"
              borderBottomColor={isActive ? 'green.400' : 'transparent'}
              color={isActive ? 'white' : 'whiteAlpha.600'}
              bg={isActive ? 'whiteAlpha.100' : 'transparent'}
              _hover={{
                color: 'white',
                bg: 'whiteAlpha.50',
              }}
              borderTopRadius="md"
            >
              <Text m={0}>{tab.label}</Text>
            </Box>
          );
        })}
      </Flex>

      <StandingsChart fullPage={true} view={activeTab} />
    </Container>
  );
};

export default StandingsPage;
